import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from '../../../styles';
import { FireAndForgetElement } from '../../parallax/components';

const StyledHeader = styled(FireAndForgetElement)`
  margin: 0 0 ${props => props.breakpoint !== 'phone' ? 10.625 : 3}rem;
  width: 100%;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  padding: 1.5rem 0;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  color: ${styles.color.SLATE_LIGHT};
/*
  > div {
    width: auto;
  }
  */
  &:after {
    width: 2px;
    background: ${styles.color.SLATE_LIGHT};
    height: ${props => props.breakpoint !== 'phone' ? 3.25 : 2}rem;
    content: '';
    position: absolute;
    top: ${props => props.breakpoint !== 'phone' ? 5 : 4}rem;
    transition-property: transform;
    transition-timing-function: ${styles.easing.outQuad};
    transition-delay: 0.5s;
    transition-duration: 0.35s;
    transform: scale(1, 1) translate3d(0,0,0);;
    transform-origin: 0 0;
  }

  h4 {
    font-family: 'ApercuMono';
    text-transform: uppercase;
    font-size: 1rem;
    ${styles.media.tablet`
      font-size: 1.25rem;
    `}${styles.media.phone`
      font-size: 1rem;
    `}
    height: 1em;
    overflow: hidden;

    span {
      display: block;
      transition-property: transform;
      transition-timing-function: ${styles.easing.outQuad};
      transition-delay: 0.25s;
      transition-duration: 0.35s;
      transform: translate3d(0, 0, 0);
      width: 100%;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &.initial {
    h4 {
      span {
        transform: translate3d(0, 1em, 0);
      }
    }

    &:after {
      transform: scale(1, 0) translate3d(0,0,0);
    }
  }
`;

const SectionHeader = props => {
  const { breakpoint, title } = props;
  return (
    <StyledHeader Tag="header" breakpoint={breakpoint}>
      <h4>
        <span>{title}</span>
      </h4>
    </StyledHeader>
  );
};

SectionHeader.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  }
}

export default connect(mapStateToProps)(SectionHeader);



// WEBPACK FOOTER //
// ./src/modules/pages/components/SectionHeader.js